module.exports = __webpack_public_path__ + "img/ktb.6003b833.svg";